import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';
import { MessageCircleIcon, SendIcon, MailIcon, ShieldCheckIcon } from 'lucide-react';
export const Footer: React.FC = () => {
  return <footer className="bg-black text-white" data-id="element-94">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-95">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-96">
          {/* Logo and tagline */}
          <div data-id="element-97">
            <Logo size="small" className="text-white" data-id="element-98" />
            <p className="mt-4 text-sm text-gray-300" data-id="element-99">
              Helping Company Owners Find Their Way Forward
            </p>
            <div className="mt-4 flex items-center text-xs text-gray-400" data-id="element-100">
              <ShieldCheckIcon className="h-4 w-4 mr-2 text-red-600" data-id="element-101" />
              <span data-id="element-102">GDPR Compliant</span>
            </div>
          </div>
          {/* Quick links */}
          <div data-id="element-103">
            <h3 className="text-sm font-semibold text-white tracking-wider uppercase" data-id="element-104">
              Quick Links
            </h3>
            <ul className="mt-4 space-y-2" data-id="element-105">
              <li data-id="element-106">
                <Link to="/" className="text-sm text-gray-300 hover:text-white" data-id="element-107">
                  Home
                </Link>
              </li>
              <li data-id="element-108">
                <Link to="/services" className="text-sm text-gray-300 hover:text-white" data-id="element-109">
                  Services & Pricing
                </Link>
              </li>
              <li data-id="element-110">
                <Link to="/faq" className="text-sm text-gray-300 hover:text-white" data-id="element-111">
                  FAQ
                </Link>
              </li>
              <li data-id="element-112">
                <Link to="/contact" className="text-sm text-gray-300 hover:text-white" data-id="element-113">
                  Contact
                </Link>
              </li>
              <li data-id="element-114">
                <Link to="/terms" className="text-sm text-gray-300 hover:text-white" data-id="element-115">
                  T&C's
                </Link>
              </li>
            </ul>
          </div>
          {/* Contact */}
          <div data-id="element-116">
            <h3 className="text-sm font-semibold text-white tracking-wider uppercase" data-id="element-117">
              Contact Us
            </h3>
            <ul className="mt-4 space-y-2" data-id="element-118">
              <li className="flex items-center" data-id="element-119">
                <MessageCircleIcon className="h-5 w-5 text-red-600 mr-2" data-id="element-120" />
                <a href="https://wa.me/YOURPHONENUMBER" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-300 hover:text-white" data-id="element-121">
                  WhatsApp
                </a>
              </li>
              <li className="flex items-center" data-id="element-122">
                <SendIcon className="h-5 w-5 text-red-600 mr-2" data-id="element-123" />
                <a href="https://t.me/YOURUSERNAME" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-300 hover:text-white" data-id="element-124">
                  Telegram
                </a>
              </li>
              <li className="flex items-center" data-id="element-125">
                <MailIcon className="h-5 w-5 text-red-600 mr-2" data-id="element-126" />
                <a href="mailto:info@debtrescue.it.com" className="text-sm text-gray-300 hover:text-white" data-id="element-127">
                  info@debtrescue.it.com
                </a>
              </li>
            </ul>
          </div>
          {/* Company Info */}
          <div data-id="element-128">
            <h3 className="text-sm font-semibold text-white tracking-wider uppercase" data-id="element-129">
              Company Info
            </h3>
            <ul className="mt-4 space-y-2 text-sm text-gray-300" data-id="element-130">
              <li data-id="element-131">Registered in England</li>
              <li data-id="element-132">Response time: 24hrs</li>
              <li data-id="element-133">150+ companies helped</li>
            </ul>
          </div>
        </div>
        <div className="mt-8 border-t border-gray-800 pt-8" data-id="element-134">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center" data-id="element-135">
            <div className="text-xs text-gray-400" data-id="element-136">
              <p data-id="element-137">Payment methods: Bank transfer | Card payment (+3% fee)</p>
            </div>
            <div className="text-xs text-gray-400 mt-4 md:mt-0" data-id="element-138">
              <p data-id="element-139">
                &copy; {new Date().getFullYear()} Debt Rescue. All rights
                reserved.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>;
};